module.exports = __webpack_public_path__ + "static/media/baa.271301bd.png";